// extracted by mini-css-extract-plugin
export default {"redirectLink":"navbar_redirectLink__nZSbc"};